import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import NumberInput from 'fe-design-base/atoms/NumberInput';
import Text from 'fe-design-base/atoms/Text';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';

import { isInvalidValue, numberToCurrency } from './util';

const { cx } = cxHelpers('CashTips');

const CashTips = ({
  cashTips,
  cashTipOutEligible,
  handleChangeCashTips,
  trackTipsClick,
}) => (
  <Box className={cx()} column>
    <Box w={100} onClick={partial(trackTipsClick, 'cash_tips')}>
      <Box pb={8}>
        <Text
          color="mono700"
          textAlign="left"
          variant="bodySmBoldTight"
          i18n="timecard_modal_v3.tips_edit_section.cash_tips"
        />
      </Box>
      {cashTipOutEligible ? (
        <Box pv={8} vcenter>
          <Text variant="body" color="mono900">
            {numberToCurrency(cashTips ?? 0)}
          </Text>
        </Box>
      ) : (
        <NumberInput
          name="cash_tips"
          size="medium"
          value={cashTips}
          error={isInvalidValue(cashTips)}
          onChange={handleChangeCashTips}
          placeholder="$0.00"
          places="2"
          prefix="$"
          leftAlign
          dataTestId="cashTipsInput"
        />
      )}
    </Box>
  </Box>
);

CashTips.propTypes = {
  cashTips: PropTypes.number,
  cashTipOutEligible: PropTypes.bool,
  trackTipsClick: PropTypes.func.isRequired,
  handleChangeCashTips: PropTypes.func.isRequired,
};

export default CashTips;
